import React from "react";
import { Loader2 } from "lucide-react";

import { cn } from "@/lib/utils";
import { Container } from "@/components/layout/main-content/Container";

//

export interface LoaderFullScreenProps {
  className?: string;
}

//

export const LoaderFullScreen: React.FC<LoaderFullScreenProps> = ({ className }) => {
  return (
    <Container className={cn("flex h-dvh", className)}>
      <Loader2 className="m-auto animate-spin" />
    </Container>
  );
};
